module.exports = __webpack_public_path__ + "img/copay-savings.f884d7eb.png";